export default __webpack_public_path__ + "3bda1c3e58b2c96ae5b7d306ba47e5aa.png";